import { Pressable, View } from 'react-native';
import { Text } from '@/components/Text';
import { navigate } from '@/navigations/RootNavigation';
import { useDialog } from '@/hooks/useDialog';
import { useStoreActions, useStoreState } from '../../stores/store';
import { chargebeeOptin } from '@/api/services/chargebee';
import { TextLink } from '@/components/TextLink';
import { logError } from '@/utils/logHandling';

export const SelectHealthInsurance = () => {
  const signedInUser = useStoreState((state) => state.signedInUser);
  const setUserData = useStoreActions((actions) => actions.setUserData);
  const { removeDialog, showDialog } = useDialog();

  return (
    <View className="flex-1 w-full p-4 space-y-8">
      <Text className="text-xl">
        Sind Sie in einer gesetzlichen Krankenkasse versichert? Oder sind Sie
        bei einer privaten Krankenkassen versichert bzw. möchten die App auf
        eigene Rechnung kaufen?
      </Text>
      <View className="w-full flex-row justify-between">
        <Pressable
          className="p-2 bg-green-neolexon rounded-md mr-2 flex-row justify-center items-center"
          onPress={() => {
            navigate('DigaCodes');
            removeDialog();
          }}
        >
          <Text className="text-white text-lg">
            Gesetzlich versichert in Deutschland
          </Text>
        </Pressable>
        <Pressable
          className="p-2 bg-green-neolexon rounded-md flex-row justify-center items-center"
          onPress={() => {
            if (signedInUser.user?.digaUser === true) {
              removeDialog();
              showDialog({
                title: 'Einwilligung zur Datenverarbeitung',
                contentComponent: () => (
                  <Text className="text-lg p-4">
                    Ich willige ein, dass zur Zahlungsabwicklung meine Daten
                    durch die externen Dienstleister Stripe (Stripe Payments
                    Europe, Ltd., 1 Grand Canal Street Lower, Grand Canal Dock,
                    Dublin, Irland) und Chargebee (909 Rose Avenue, Suite 610,
                    North Bethesda, MD 20852, USA) verarbeitet werden. Diese
                    externen Dienstleister sind zur gesetzmäßigen, vertraulichen
                    und sicheren Behandlung Ihrer Daten verpflichtet und dürfen
                    Ihre Daten nur verwenden, soweit dies zur Erfüllung ihrer
                    Aufgabe erforderlich ist. Weitere Infos finden Sie in
                    unserer{' '}
                    <TextLink href="https://neolexon.de/datenschutzerklaerung/">
                      Datenschutzerklärung
                    </TextLink>
                    . Ich kann diese Einwilligung jederzeit widerrufen.
                  </Text>
                ),
                confirmAction: {
                  label: 'Einwilligen',
                  onPress: async () => {
                    await chargebeeOptin()
                      .then((response) => {
                        if (response.data.message.includes('successful')) {
                          setUserData({
                            ...signedInUser,
                            user: { ...signedInUser.user, digaUser: false },
                          });
                          navigate('LicenseBooking');
                          removeDialog();
                        }
                      })
                      .catch((e) => {
                        logError(e);
                      });
                  },
                },
                cancelAction: {
                  label: 'Abbrechen',
                  onPress: removeDialog,
                },
              });
            } else {
              navigate('LicenseBooking');
              removeDialog();
            }
          }}
        >
          <Text className="text-white text-lg">
            Privat versichert/Selbstzahler
          </Text>
        </Pressable>
      </View>
    </View>
  );
};
